export default __webpack_public_path__ + "static/ot_card_3-45abdb743f82a7e95292b90c1313f75b.png";